<script>
export default {
    data() {
        return {
            current: 0,
            timer: function(){}
        }
    },
    props: {
        items: Array,
        themeDir: String
    },
    methods: {
        activateItem(key) {
            this.current = key;
            clearInterval(this.timer);
        }
    },
    mounted() {
        this.timer = setInterval(() => {
            if (this.current < (this.items.length -1)) {
                ++this.current;
            } else {
                this.current = 0;
            }
        }, 8000)
    }
}
</script>

<style>
    .fade-enter-active,
    .fade-leave-active {
        transition: all 2s ease;
    }

    .fade-enter-from {
        visibility: visible;
        opacity: 0;
    }

    .fade-leave-from, .fade-leave-to {
        visibility: hidden;
        width: 0;
        opacity: 0;
    }
</style>

<template>
    <div>
        <div class="flex flex-nowrap w-full overflow-x-hidden">
            <div v-for="(item, key) in items" class='mb-3 grow w-full min-w-full' :class="{'visible opacity-100 order-1': key === this.current, 'order-2 invisible overflow-hidden opacity-0': key !== this.current}">
                <div class='max-w-2xl'>
                    <blockquote class='text-lg mb-3'>&quot;{{item.Content}}&quot;</blockquote>
                    <div class='font-bold text-lg'>{{item.Author}}</div>
                </div>
            </div>
        </div>
<!--            <Transition name='fade'>-->
<!--            </Transition>-->

        <ol class='flex gap-3'>
            <li v-for="(item, key) in items" >
                <button @click='activateItem(key)' :disabled="key === this.current">
                    <img :src="`${themeDir}/images/radio_button_checked_black_24dp.svg`" alt="Current" width="18" height="18" :class="{'hidden': key !== this.current}">
                    <img :src="`${themeDir}/images/radio_button_unchecked_black_24dp.svg`" alt="Current" width="18" height="18" :class="{'hidden': key === this.current}">
                </button>
            </li>
        </ol>
    </div>
</template>
